/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {SWIPER_OPTIONS as BASE_SWIPER_OPTIONS} from '@amblique/base/app/constants/swiper-options';
import breakpoints from '@amblique/king-living/app/theme/foundations/breakpoints';

/**
 * Swiper options presets
 * @link [Swiper API](https://swiperjs.com/swiper-api#parameters)
 */
export const SWIPER_OPTIONS = {
  ...BASE_SWIPER_OPTIONS,


  /**
   * Default options - always applied
   */
  'default': {
    ...BASE_SWIPER_OPTIONS.default,

    pagination: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
  },


  /**
   * Product Gallery
   */
  'product_gallery': {
    effect: 'slide',
    navigation: true,
    slidesPerGroup: 1,
    slidesPerView: 1,
    pagination: true,
  },

  'CF-010': {
    autoplay: {
      enabled: true,
      delay: 5000,
      pauseOnMouseEnter: false,
    },
    navigation: true,
    pagination: {
      enabled: true,
      type: 'fraction',
    },
  },

  'CF-011': {
    loop: true,
    navigation: false,
    pagination: false,
  },

  'CF-011-Thumbs': {
    loop: true,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 40,
    navigation: false,
    pagination: false,
    breakpoints: {
      [parseInt(breakpoints.breakpoints.base)]: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
      },
      [parseInt(breakpoints.breakpoints.md)]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 40,
      },
    },
  },

  'CF-012': {
    navigation: true,
    pagination: false,
  },

  'CF-012-Thumbs': {
    slidesPerView: 'auto',
    spaceBetween: 20,
    navigation: false,
    pagination: false,
    allowTouchMove: false,
  },

  'CF-013': {
    navigation: false,
    pagination: false,
    slidesPerGroup: 1,
    slidesPerView: 1,
  },

  'CF-013-Thumbs': {
    navigation: false,
    pagination: false,
    slidesPerView: 'auto',
    centerInsufficientSlides: true,
    centerSlides: true,
    centeredSlidesBounds: true,
    breakpoints: {
      [parseInt(breakpoints.breakpoints.base)]: {
        spaceBetween: 26,
      },
      [parseInt(breakpoints.breakpoints.md)]: {
        spaceBetween: 56,
      },
    },
  },

  'CF-016': {
    navigation: false,
    pagination: false,
    freeMode: true,
    slidesPerGroup: 3.5,
    slidesPerView: 3.5,
  },

  'CF-022': {
    navigation: false,
    pagination: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    freeMode: true,
  },

  'CF-046': {
    navigation: true,
    pagination: false,
    freeMode: true,
    slidesPerView: 'auto',
    spaceBetween: 4,
  },
};

export * from '@amblique/base/app/constants/swiper-options';
